import _Object$assign from "babel-runtime/core-js/object/assign";
import _JSON$stringify from "babel-runtime/core-js/json/stringify";

import sysConfig from "../../config/sysConfig";
import date from "../date";
import store from "../../vuex";
import des from "@/tools/libs/standard-des";
import storage from "@/tools/storage.js";

var ERROR_RUNTIME = "运行时错误";
var ERROR_SCRIPT = "脚本加载错误";
var ERROR_STYLE = "样式加载错误";
var ERROR_IMAGE = "图片加载错误";
var ERROR_AUDIO = "音频加载错误";
var ERROR_VIDEO = "视频加载错误";
var ERROR_CONSOLE = "错误CONSOLE.ERROR";
var ERROR_TRY_CATHC = "TRY_CATCH错误";
var CONSOLE_INFO = "正常的CONSOLE.LOG";
var RESPONSE_ERROR = "接口返回的错误";
var MAX_ERROR_NUM = 1024 * 100;
var reporting = false;
var IS_COLLECT_LOG = "1";
var COMMON_PARAM = null;

var LOAD_ERROR_TYPE = {
  SCRIPT: ERROR_SCRIPT,
  LINK: ERROR_STYLE,
  IMG: ERROR_IMAGE,
  AUDIO: ERROR_AUDIO,
  VIDEO: ERROR_VIDEO };

function isDevEvn() {
  return process.env.NODE_ENV === "development" || window.isDev === "1";
}

function report(msgArr, notClear) {
  reporting = true;
  sysConfig.$syscfg.reportErrorLog({
    errorLog: msgArr || _VTMErrMsgs }).then(function (data) {
    if (!notClear) {
      if (_VTMErrMsgs2 && _VTMErrMsgs2.length) {
        _VTMErrMsgs = _.cloneDeep(_VTMErrMsgs2);
        _VTMErrMsgs2 = [];
      } else {
        _VTMErrMsgs = [];
      }
    }
    reporting = false;
    console.info("VTM前端日志上报成功");
  }).catch(function (err) {
    reporting = false;

    var lostLength = _VTMErrMsgs.length;
    consoleLog("日志上传失败，有" + lostLength + "条记录丢失");
    _VTMErrMsgs = _.cloneDeep(_VTMErrMsgs2);
    _VTMErrMsgs2 = [];
    console.error("非现场前端日志上报出错：" + err);
  });
}

function handleError(errorLog, isNowReport) {
  var tempPath = _.get(vm, "$route.path", "") || "";

  if (IS_COLLECT_LOG != "1") {
    return;
  }

  if (Object.prototype.toString.call(errorLog.desc) == "[object Arguments]") {
    var tmpStr = "";
    _.map(Array.prototype.slice.call(errorLog.desc) || [], function (v) {
      try {
        tmpStr = tmpStr + (_.isString(v) ? v : _JSON$stringify(v));
        if (tmpStr.length > 1024) {
          tmpStr = tmpStr.substr(0, 1024);
        }
      } catch (err) {}
    });
    errorLog.desc = tmpStr;
  }
  var cloneErrorLog = _.cloneDeep(errorLog);
  var custInfo = JSON.parse(sessionStorage.getItem("CUSTOMER_INFO") || "{}") || {};
  var bizRouteTable = store.state.bizRouteTable || {};
  var errMsg = cloneErrorLog.desc || "";
  var busiCode = store.state.busicode || "";
  var errMsgString = "";
  try {
    errMsgString = _.isString(errMsg) ? errMsg : _JSON$stringify(errMsg);
  } catch (err) {}


  if (errMsgString == "" || _.isString(errMsgString) && errMsgString.indexOf("data:image/jpeg;base64,") != -1) {
    return false;
  }

  if (errMsgString.includes("%c")) {
    return false;
  }
  var errObj = _Object$assign({}, cloneErrorLog, {
    time: date.getClientDateTime(),
    busi_code: busiCode,
    id_code: window.logDes.encrypt(custInfo.ID_CODE, "axzq") || "",
    currentRouteInfo: tempPath
  }, errMsg && _.isString(errMsg) && errMsg.indexOf("response") != -1 ? {
    type: RESPONSE_ERROR,
    msgCode: errMsg.split("：")[1] && errMsg.split("：")[1].split(",") && errMsg.split("：")[1].split(",")[0],
    serviceId: errMsg.split("：")[2] && errMsg.split("：")[1].split(",") && errMsg.split("：")[1].split(",")[0],
    serviceCode: errMsg.split("：")[3]
  } : {});
  if (isNowReport && reporting) {
    report([errObj], true);
    return;
  }

  try {
    var configFieldsArr = ["ID_CODE", "CUACCT_CODE", "CUST_CODE", "CUST_FNAME", "YMT_CODE"];
    if (errObj.desc && !_.isEmpty(custInfo) && _.isString(errObj.desc)) {
      _.each(configFieldsArr, function (field) {
        if (!!custInfo[field] && errObj.desc.includes(custInfo[field])) {
          errObj.desc = errObj.desc.replace(new RegExp(custInfo[field], "g"), window.logDes.encrypt(custInfo[field], "axzq"));
        }
      });
    }

    if (/(1[3|4|5|7|8][\d]{9}|0[\d]{2,3}-[\d]{7,8}|400[-]?[\d]{3}[-]?[\d]{4})/g.test(errObj.desc) && errObj.desc && _.isString(errObj.desc)) {
      var matchArr = errObj.desc.match(/(1[3|4|5|7|8][\d]{9}|0[\d]{2,3}-[\d]{7,8}|400[-]?[\d]{3}[-]?[\d]{4})/g);
      _.each(matchArr, function (v) {
        if (!!v) {
          var reg = new RegExp("" + v, "g");
          errObj.desc = _.isString(errObj.desc) && errObj.desc.replace(reg, window.logDes.encrypt(v, "axzq"));
        }
      });
    }
  } catch (er) {
    consoleLogNow("脱敏失败的的串：", errObj.desc);
    consoleLog("日志脱敏解析失败，原因：", er);
  }
  try {
    _VTMErrMsgs.push(errObj);

    if ((_JSON$stringify(_VTMErrMsgs).length >= parseInt(MAX_ERROR_NUM) || _VTMErrMsgs.length > 50) && !reporting || isNowReport) {
      report();
    } else if (reporting) {
      _VTMErrMsgs2.push(errObj);
    }
  } catch (err) {
    consoleLogNow("判断是否需要上传日志方法调用失败", err);
  }
}

function formatTryCatchError(error) {
  return {
    type: ERROR_TRY_CATHC,
    desc: error.message,
    stack: error.stack
  };
}

var showWarn = function showWarn() {
  var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "未知错误";

  if (isDevEvn()) {}
};

var errorHandleVue = function errorHandleVue(err, compInfo, info) {
  var formatErr = {
    type: err.name,
    desc: err.message + err.stack
  };
  handleError(formatErr);
  showWarn(err.stack);
  if (isDevEvn()) {
    console.info("errorHanle", formatErr);
    console.info("compInfo", compInfo);
    console.info("compInfo", info);
  }
};

function __init() {
  window._VTMErrMsgs = [];
  window._VTMErrMsgs2 = [];
  window._report = report;
  window.logDes = des;
  window.addEventListener("error", function (event) {
    if (event.origin === "") {
      consoleLog("发件人的身份为空");
    }

    var errorTarget = event.target;
    var message = event.message,
        filename = event.filename,
        lineno = event.lineno,
        colno = event.colno,
        error = event.error,
        path = event.path;

    if (isDevEvn()) {
      console.info("错误铺抓参数", event.error);
      console.info("path", path);
    }

    if (errorTarget !== window && errorTarget && errorTarget.nodeName && LOAD_ERROR_TYPE[errorTarget.nodeName.toUpperCase()]) {
      handleError(formatLoadError(errorTarget));
    } else {
      handleError(formatRuntimerError(message, filename, lineno, colno, error));
    }

    showWarn(error || message || errorTarget);
  }, true);

  window.addEventListener("unhandledrejection", function (event) {
    if (event.origin === "") {
      consoleLog("发件人的身份为空");
    }
    if (isDevEvn()) {
      console.info("Unhandled Rejection at:", event.promise, "reason:", event.reason);
    }
    handleError(event);
    showWarn(event.reason);
  }, true);

  window.consoleLog = function () {
    var errorLog = {
      type: CONSOLE_INFO,
      desc: arguments
    };
    if (isDevEvn()) {
      var _console;

      (_console = console).info.apply(_console, arguments);
    }
    handleError(errorLog);
  };

  window.consoleError = function () {
    var errorLog = {
      type: ERROR_CONSOLE,
      desc: arguments[0]
    };
    if (arguments[1] && arguments[1] instanceof Error) {
      errorLog.desc += arguments[1].stack;
    }
    if (isDevEvn()) {
      var _console2;

      (_console2 = console).error.apply(_console2, arguments);
    }
    handleError(errorLog);
  };

  window.consoleLogNow = function () {
    var errorLog = {
      type: CONSOLE_INFO,
      desc: arguments
    };
    if (isDevEvn()) {
      var _console3;

      (_console3 = console).info.apply(_console3, arguments);
    }
    handleError(errorLog, true);
  };

  COMMON_PARAM = storage.$storage.getJsonLocal("SYS_COMM_PARAM_OBJS") || {};
  MAX_ERROR_NUM = COMMON_PARAM.FXC_LOG_MAX_ERROR_NUM || MAX_ERROR_NUM;
  IS_COLLECT_LOG = COMMON_PARAM.FXC_IS_COLLECT_LOG || IS_COLLECT_LOG;
}

function formatRuntimerError(message, source, lineno, colno, error) {
  return {
    type: ERROR_RUNTIME,
    desc: message + " at " + source + ":" + lineno + ":" + colno,
    stack: error && error.stack ? error.stack : "no stack" };
}

function handleTryCatchError(error) {
  handleError(formatTryCatchError(error));
}

function formatLoadError(errorTarget) {
  return {
    type: LOAD_ERROR_TYPE[errorTarget.nodeName.toUpperCase()],
    desc: errorTarget.baseURI || "" + "@" + (errorTarget.src || errorTarget.href),
    stack: errorTarget.stack || "no stack"
  };
}

function changeLogParam() {
  COMMON_PARAM = storage.$storage.getJsonLocal("SYS_COMM_PARAM_OBJS") || {};
  MAX_ERROR_NUM = COMMON_PARAM.FXC_LOG_MAX_ERROR_NUM || MAX_ERROR_NUM;
  IS_COLLECT_LOG = COMMON_PARAM.FXC_IS_COLLECT_LOG || IS_COLLECT_LOG;
}

export default {
  initMonitor: __init,
  errorHandleVue: errorHandleVue,
  changeLogParam: changeLogParam
};


//////////////////
// WEBPACK FOOTER
// ./src/tools/logSystem/log.js
// module id = 316
// module chunks = 2